<template>
  <a-button-group :class="['op-group', $attrs.class]">
    <Tooltip placement="top" :content="$t('fu-zhi-dao-ge-ren-kong-jian')">
      <a-button class="btn-copy" @click="handleCopy">
        <iconpark-icon class="icon" name="card-op-copy"></iconpark-icon>
      </a-button>
    </Tooltip>
    <BtnDelete class="btn-delete">
      <iconpark-icon class="icon" name="card-op-delete"></iconpark-icon>
    </BtnDelete>
  </a-button-group>
</template>

<script lang="ts" setup>
import Tooltip from '@rendora/design/components/tooltip/Tooltip.vue';

import type { Template } from '~/api/interface';
import BtnDelete from './btn-delete.vue';
const ctx: any = inject('personal-page-ctx');
const cardItem = inject<Template>('card-item');

const handleCopy = () => {
  ctx.actionCopy(cardItem);
};
</script>

<style lang="scss" scoped>
.icon {
  font-size: 18px;
}
</style>

<style lang="scss" scoped>
.op-group {
  flex: 1;
  &:deep(button) {
    flex: 1;
    padding-top: 6px;
    border-radius: 6px;
    color: var(--text-1-70);
  }
}
</style>
